import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface InitialStateI {
  logId?: number;
  campaignIdViewCounts?: {
    [key: number]: {
      amount: number;
      expirationDate?: number;
      campaignHideDuration?: number;
      uniqueViews?: number;
    };
  };
}

const initialState: InitialStateI = {};

const backgroundSlice = createSlice({
  name: "background",
  initialState,
  reducers: {
    setLogId: (state, action: PayloadAction<number | undefined>) => {
      state.logId = action.payload;
    },
    setCampaignIdViewCount: (
      state,
      action: PayloadAction<{
        adId: number;
        amount: number;
        expirationDate: number;
      }>
    ) => {
      if (state.campaignIdViewCounts) {
        state.campaignIdViewCounts[action.payload.adId] = {
          amount: action.payload.amount,
          expirationDate: action.payload.expirationDate,
        };
      } else {
        state.campaignIdViewCounts = {
          [action.payload.adId]: {
            amount: action.payload.amount,
            expirationDate: action.payload.expirationDate,
          },
        };
      }
    },
    incCampaignIdViewCount: (state, action: PayloadAction<number>) => {
      if (state.campaignIdViewCounts?.[action.payload]) {
        const prevAmount =
          state.campaignIdViewCounts[action.payload].amount || 0;
        state.campaignIdViewCounts[action.payload] = {
          ...state.campaignIdViewCounts[action.payload],
          amount: prevAmount + 1,
        };
      } else {
        state.campaignIdViewCounts = {
          ...state.campaignIdViewCounts,
          [action.payload]: {
            amount: 1,
          },
        };
      }
    },
    setCampaignIdExpirationDate: (
      state,
      action: PayloadAction<{ campaignId: number; expirationDate?: number }>
    ) => {
      if (state.campaignIdViewCounts) {
        state.campaignIdViewCounts[action.payload.campaignId] = {
          ...state.campaignIdViewCounts[action.payload.campaignId],
          expirationDate: action.payload.expirationDate,
        };
      }
    },
    removeCampaignIdViewsData: (state, action: PayloadAction<number>) => {
      if (state.campaignIdViewCounts) {
        delete state.campaignIdViewCounts[action.payload];
      }
    },
    setCampaignHideDuration: (
      state,
      action: PayloadAction<{ campaignId: number; duration: number }>
    ) => {
      if (state.campaignIdViewCounts) {
        state.campaignIdViewCounts[action.payload.campaignId] = {
          ...state.campaignIdViewCounts[action.payload.campaignId],
          campaignHideDuration: action.payload.duration,
        };
      }
    },
    setUniqueViews: (
      state,
      action: PayloadAction<{ campaignId: number; uniqueViews: number }>
    ) => {
      if (state.campaignIdViewCounts) {
        state.campaignIdViewCounts[action.payload.campaignId] = {
          ...state.campaignIdViewCounts[action.payload.campaignId],
          uniqueViews: action.payload.uniqueViews,
        };
      }
    },
  },
});

export default backgroundSlice.reducer;

export const {
  setLogId,
  setCampaignIdViewCount,
  incCampaignIdViewCount,
  setCampaignIdExpirationDate,
  removeCampaignIdViewsData,
  setCampaignHideDuration,
  setUniqueViews,
} = backgroundSlice.actions;
